import { BreadcrumbItem } from './BreadcrumbItem';
import { BreadcrumbLink } from './BreadcrumbLink';
import { BreadcrumbRoot } from './BreadcrumbRoot';

export const Breadcrumb = {
  Root: BreadcrumbRoot,
  Link: BreadcrumbLink,
  Item: BreadcrumbItem,
};
